/**
 * TanStack Query hooks for `top-publishers-widget`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	topPublishersWidgetQueryKeys,
	type CreateTopPublishersWidgetBody,
	type ListTopPublishersWidgetParams,
	type ListTopPublishersWidgetResponse,
	type PublisherRow,
} from "./api";

export type { PublisherRow } from "./api";

export function useTopPublishersWidgetList(
	params?: ListTopPublishersWidgetParams,
): UseQueryResult<ListTopPublishersWidgetResponse, Error> {
	return useQuery({
		queryKey: topPublishersWidgetQueryKeys.list(params),
		queryFn: () => list(params),
	});
}

export function useTopPublishersWidgetCreate(): UseMutationResult<
	PublisherRow,
	Error,
	CreateTopPublishersWidgetBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: topPublishersWidgetQueryKeys.all });
		},
	});
}

export function useTopPublishersWidgetDelete(): UseMutationResult<
	{ removed: boolean },
	Error,
	string
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: topPublishersWidgetQueryKeys.all });
		},
	});
}
